module.exports = __webpack_public_path__ + "static/media/background_consult.f174be1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_page_solutions/chifco_consulting/background_consult.png
// module id = 2289
// module chunks = 0